module.exports = __webpack_public_path__ + "img/73ABC14D.96cf6dfe.png";